import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LocationPinIcon = () => {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "10.5",
      cy: "10",
      r: "10",
      fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4996 16.0417L6.89734 10.8184C4.89538 7.91561 6.97334 3.95833 10.4996 3.95833C14.0258 3.95833 16.1037 7.9156 14.1018 10.8184L10.4996 16.0417ZM10.4996 10.4167C11.6501 10.4167 12.5829 9.48393 12.5829 8.33333C12.5829 7.18274 11.6501 6.25 10.4996 6.25C9.34896 6.25 8.41622 7.18274 8.41622 8.33333C8.41622 9.48393 9.34896 10.4167 10.4996 10.4167Z",
      fill: "var(--ds-icon-inverse, #FFFFFF)"
    })]
  });
};